import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { ArrowRight, Check } from "lucide-react";

export const NewsletterForm = ({ compact = false }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/subscribe", { email, name });
      toast.success(data.message || "You're in!");
      setDone(true);
      setEmail("");
      setName("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="flex items-center gap-3 text-brand-cyan" data-testid="newsletter-success">
        <span className="h-9 w-9 grid place-items-center rounded-full bg-brand-cyan/15">
          <Check size={18} />
        </span>
        <p className="text-sm">You're on the list. Welcome to the project.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="w-full max-w-md" data-testid="newsletter-form">
      {!compact && (
        <input
          type="text"
          placeholder="Your name (optional)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          data-testid="newsletter-name-input"
          className="w-full mb-3 bg-brand-elevated border border-white/10 rounded-full px-5 py-3 text-sm text-white placeholder:text-brand-textMuted focus:outline-none focus:ring-2 focus:ring-brand-cyan"
        />
      )}
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          required
          placeholder="you@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="newsletter-email-input"
          className="flex-1 bg-brand-elevated border border-white/10 rounded-full px-5 py-3 text-sm text-white placeholder:text-brand-textMuted focus:outline-none focus:ring-2 focus:ring-brand-cyan"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit-btn"
          className="btn-primary px-6 py-3 text-sm inline-flex items-center justify-center gap-2 disabled:opacity-60"
        >
          {loading ? "Joining…" : "Join The Community"}
          {!loading && <ArrowRight size={16} />}
        </button>
      </div>
      <p className="text-brand-textMuted text-xs mt-3">
        No spam. Just updates on the journey — and a say in where it goes.
      </p>
    </form>
  );
};
